import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { InventoryEntities } from 'client/data/models/inventory';
import { Col, Row } from 'reactstrap';
import { negate } from 'lodash-es';
import { WarrantyItemUsedDetailed } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-item-used-detailed/warranty-item-used-detailed';
import {
  isWarrantyItemEligible,
  sortWarranty,
  sortWarrantyByExpiration,
} from 'site-modules/shared/utils/inventory/warranty';
import { MAX_DETAILED_WARRANTY_USED_LIST_COUNT } from 'site-modules/shared/constants/inventory/warranty';
import { ViewMore } from 'site-modules/shared/components/inventory/view-more/view-more';
import { Accordion } from 'site-modules/shared/components/inventory/accordion/accordion';
import { WarrantyShortListUsed } from 'site-modules/shared/components/inventory/warranty-module/warranty-list/warranty-list-used/warranty-short-list-used';

export function WarrantyDetailsUsed(props) {
  const { warranty, vinData, animateWarrantyPeriodProgress } = props;
  const sortedWarranty = useMemo(() => sortWarrantyByExpiration(vinData, sortWarranty(warranty)), [vinData, warranty]);

  const sliceIndex = useMemo(() => {
    const index = sortedWarranty.findIndex(negate(isWarrantyItemEligible(vinData)));
    return index === -1
      ? MAX_DETAILED_WARRANTY_USED_LIST_COUNT
      : Math.min(MAX_DETAILED_WARRANTY_USED_LIST_COUNT, index);
  }, [sortedWarranty, vinData]);

  return (
    <Accordion>
      <Row tag="ul" className="list-unstyled mb-0">
        {sortedWarranty.slice(0, sliceIndex).map((warrantyItem, index) => (
          <Col key={warrantyItem.id} tag="li" sm={12} lg={6} className={classnames({ 'mt-1 mt-lg-0': !!index })}>
            <WarrantyItemUsedDetailed
              warrantyItem={warrantyItem}
              vinData={vinData}
              animateWarrantyPeriodProgress={animateWarrantyPeriodProgress}
            />
          </Col>
        ))}
      </Row>
      {!sliceIndex && (
        <div className="pt-1">
          <WarrantyShortListUsed warranty={sortedWarranty.slice(sliceIndex)} vinData={vinData} />
        </div>
      )}
      {!!sliceIndex && sortedWarranty.length > sliceIndex && (
        <ViewMore
          collapsedSummary="All manufacturer warranties"
          expandedSummary="Hide all manufacturer warranties"
          className="mt-1_5"
        >
          <div className="mt-1_5">
            <WarrantyShortListUsed warranty={sortedWarranty.slice(sliceIndex)} vinData={vinData} />
          </div>
        </ViewMore>
      )}
      <p className="size-12 mb-0 mt-1_5 text-cool-gray-40">
        *Warranty remaining values are estimated based on the vehicle year and mileage provided by the dealer. Confirm
        exact warranty coverage with the dealer and the manufacturer before purchasing.
      </p>
    </Accordion>
  );
}

WarrantyDetailsUsed.propTypes = {
  warranty: InventoryEntities.Warranty.isRequired,
  vinData: InventoryEntities.InventoryVin.isRequired,
  animateWarrantyPeriodProgress: PropTypes.bool.isRequired,
};
